import React from 'react';

const SalesSection = ({
  stats,
  salesPeriod,
  setSalesPeriod,
  targetDate,
  setTargetDate,
  salesSearch,             
  setSalesSearch,          
  monthlySalesTrend,       
  periodDetailList,
  periodTotalSales,
  handlePrintSales,
  handleDownloadSalesExcel
}) => {
  const getStatusBadgeStyle = (status) => {
    const base = { padding: '5px 12px', borderRadius: '6px', fontSize: '11px', fontWeight: '800' };
    if (status === '접수') return { ...base, background: '#fff7ed', color: '#ea580c' };
    if (status === '진행중') return { ...base, background: '#eff6ff', color: '#2563eb' };
    if (status === '보류') return { ...base, background: '#fefce8', color: '#ca8a04' };
    return { ...base, background: '#f0fdf4', color: '#16a34a' };
  };

  const style = {
    grid4: { display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '20px', marginBottom: '30px' },
    card: { background: 'white', padding: '30px', borderRadius: '20px', boxShadow: '0 4px 25px rgba(0,0,0,0.05)', marginBottom: '30px' },
    kpiCard: { padding: '25px', borderRadius: '15px', color: 'white', display: 'flex', flexDirection: 'column', minHeight: '130px', justifyContent: 'center', boxShadow: '0 4px 15px rgba(0,0,0,0.05)' },
    kpiTitle: { fontSize: '13px', fontWeight: '700', opacity: 0.85, marginBottom: '10px', letterSpacing: '0.5px' },
    kpiValue: { fontSize: '24px', fontWeight: 'bold' },
    actionPrintBtn: { padding: '10px 18px', background: '#3b82f6', color: 'white', border: 'none', borderRadius: '10px', fontWeight: 'bold', cursor: 'pointer', fontSize: '13px', display: 'flex', alignItems: 'center', gap: '5px' },
    actionExcelBtn: { padding: '10px 18px', background: '#10b981', color: 'white', border: 'none', borderRadius: '10px', fontWeight: 'bold', cursor: 'pointer', fontSize: '13px', display: 'flex', alignItems: 'center', gap: '5px' },
    tabButton: (isActive) => ({
      padding: '6px 12px', border: 'none', borderRadius: '8px', cursor: 'pointer', fontSize: '12px', fontWeight: 'bold',
      background: isActive ? '#1e293b' : 'transparent',
      color: isActive ? 'white' : '#64748b',
      transition: 'all 0.2s'
    }),
    input: { padding: '10px 15px', border: '1px solid #cbd5e1', borderRadius: '8px', outline: 'none', fontSize: '14px', background: 'white' },
    table: { width: '100%', borderCollapse: 'collapse', marginTop: '15px' },
    th: { background: '#f8fafc', padding: '14px 12px', textAlign: 'left', color: '#64748b', fontSize: '13px', fontWeight: 'bold', borderBottom: '2px solid #e2e8f0' },
    td: { padding: '14px 12px', fontSize: '14px', borderBottom: '1px solid #f1f5f9', color: '#1e293b' }
  };

  let periodTotalPartsSales = 0;
  let periodTotalLaborSales = 0;

  const enrichedList = periodDetailList.map(r => {
    let partsSales = 0;
    let laborSales = 0;
    if (r.parts && Array.isArray(r.parts)) {
      r.parts.forEach(p => {
        partsSales += (Number(p.price) || 0) * (Number(p.qty) || 0); 
        laborSales += (Number(p.labor) || 0);                        
      });
    }
    periodTotalPartsSales += partsSales;
    periodTotalLaborSales += laborSales;
    return { ...r, partsSales, laborSales };
  });

  const maxTotalSale = Math.max(...monthlySalesTrend.map(m => m.total), 1);

  return (
    <>
      <div style={style.grid4}>
        <div style={{...style.kpiCard, background: 'linear-gradient(135deg, #0f172a, #1e293b)'}}>
          {/* 🚀 (VAT포함) 제거 및 (공급가)로 교체 */}
          <div style={style.kpiTitle}>💳 전체 누적 매출 총액 (공급가)</div>
          <div style={style.kpiValue}>₩ {stats.totalAsAmount.toLocaleString()}</div>
        </div>
        <div style={{...style.kpiCard, background: 'linear-gradient(135deg, #10b981, #059669)'}}>
          <div style={style.kpiTitle}>💰 선택 조건 합계 매출 (공급가)</div>
          <div style={style.kpiValue}>₩ {periodTotalSales.toLocaleString()}</div>
        </div>
        <div style={{...style.kpiCard, background: 'linear-gradient(135deg, #0ea5e9, #0284c7)'}}>
          <div style={style.kpiTitle}>⚙️ 선택 조건 부품 매출 (공급가)</div>
          <div style={style.kpiValue}>₩ {periodTotalPartsSales.toLocaleString()}</div>
        </div>
        <div style={{...style.kpiCard, background: 'linear-gradient(135deg, #8b5cf6, #7c3aed)'}}>
          <div style={style.kpiTitle}>🔧 선택 조건 정비/공임 매출 (공급가)</div>
          <div style={style.kpiValue}>₩ {periodTotalLaborSales.toLocaleString()}</div>
        </div>
      </div>

      <div style={style.card}>
        <h3 style={{ margin: '0 0 10px 0', fontSize: '16px', color: '#1e293b' }}>📈 최근 12개월 매출 추이 시각화 (공급가 기준)</h3>
        
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '15px', fontSize: '12px', fontWeight: 'bold', marginBottom: '15px' }}>
          <span style={{ color: '#10b981' }}>■ 총 합계</span>
          <span style={{ color: '#0ea5e9' }}>■ 부품 매출</span>
          <span style={{ color: '#8b5cf6' }}>■ 공임 매출</span>
        </div>
        
        <div style={{ display: 'flex', height: '220px', alignItems: 'flex-end', justifyContent: 'space-between', padding: '10px 0', borderBottom: '1px solid #e2e8f0' }}>
          {monthlySalesTrend.map((data, idx) => {
            const hTotal = maxTotalSale > 0 ? (data.total / maxTotalSale) * 100 : 0;
            const hParts = maxTotalSale > 0 ? (data.parts / maxTotalSale) * 100 : 0;
            const hLabor = maxTotalSale > 0 ? (data.labor / maxTotalSale) * 100 : 0;

            return (
              <div key={idx} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '7%' }}>
                <div style={{ display: 'flex', alignItems: 'flex-end', height: '180px', gap: '3px', width: '100%', justifyContent: 'center' }}>
                  <div title={`[${data.month}] 총 합계: ₩${data.total.toLocaleString()}`} style={{ width: '28%', height: `${hTotal}%`, background: '#10b981', borderRadius: '4px 4px 0 0', minHeight: '4px', transition: 'height 0.5s ease-in-out', cursor: 'pointer' }}></div>
                  <div title={`[${data.month}] 부품 매출: ₩${data.parts.toLocaleString()}`} style={{ width: '28%', height: `${hParts}%`, background: '#0ea5e9', borderRadius: '4px 4px 0 0', minHeight: '4px', transition: 'height 0.5s ease-in-out', cursor: 'pointer' }}></div>
                  <div title={`[${data.month}] 공임 매출: ₩${data.labor.toLocaleString()}`} style={{ width: '28%', height: `${hLabor}%`, background: '#8b5cf6', borderRadius: '4px 4px 0 0', minHeight: '4px', transition: 'height 0.5s ease-in-out', cursor: 'pointer' }}></div>
                </div>
                <span style={{ fontSize: '11px', color: '#64748b', marginTop: '12px', fontWeight: 'bold' }}>{data.month.split('-')[1]}월</span>
              </div>
            );
          })}
        </div>
      </div>

      <div style={style.card}>
        <div style={{display: 'flex', flexDirection: 'column', gap: '15px', marginBottom: '20px'}}>
          <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
            <h3 style={{margin: 0, fontSize: '16px', color: '#1e293b'}}>📋 매출 상세 내역 조회 (공급가 기준)</h3>
            <div style={{display: 'flex', gap: '10px', alignItems: 'center'}}>
              <button style={style.actionPrintBtn} onClick={handlePrintSales}>🖨️ 출력하기</button>
              <button style={style.actionExcelBtn} onClick={handleDownloadSalesExcel}>📊 EXCEL 다운로드</button>
            </div>
          </div>
          
          <div style={{display:'flex', justifyContent:'flex-end', gap: '10px', alignItems: 'center', background: '#f8fafc', padding: '12px', borderRadius: '12px', border: '1px solid #e2e8f0'}}>
             <span style={{fontSize: '13px', fontWeight: 'bold', color: '#64748b'}}>🔍 매출 정밀 필터:</span>
             <div style={{display: 'flex', background: 'white', border: '1px solid #cbd5e1', borderRadius: '8px', overflow: 'hidden'}}>
               <button style={style.tabButton(salesPeriod==='전체')} onClick={()=>setSalesPeriod('전체')}>전체</button>
               <button style={style.tabButton(salesPeriod==='일일')} onClick={()=>setSalesPeriod('일일')}>일일</button>
               <button style={style.tabButton(salesPeriod==='주간')} onClick={()=>setSalesPeriod('주간')}>주간</button>
               <button style={style.tabButton(salesPeriod==='월간')} onClick={()=>setSalesPeriod('월간')}>월간</button>
             </div>
             {salesPeriod !== '전체' && (
               <input 
                 type={salesPeriod === '월간' ? "month" : "date"} 
                 style={{...style.input, width: '130px', padding: '8px'}} 
                 value={salesPeriod === '월간' ? targetDate.substring(0,7) : targetDate} 
                 onChange={e=>setTargetDate(e.target.value.length === 7 ? `${e.target.value}-01` : e.target.value)} 
               />
             )}
             <input style={{...style.input, width: '220px', padding: '8px'}} placeholder="고객명, 차량번호, 정비사 검색..." value={salesSearch} onChange={e=>setSalesSearch(e.target.value)} />
          </div>
        </div>

        <div style={{maxHeight: '450px', overflowY: 'auto', border: '1px solid #edf2f7', borderRadius: '12px'}}>
          <table style={style.table}>
            <thead style={{position: 'sticky', top: 0, background: '#f8fafc', zIndex: 5}}>
              <tr style={{borderBottom: '2px solid #eee'}}>
                <th style={{...style.th, paddingLeft: '20px', width: '50px'}}>No.</th>
                <th style={style.th}>상태</th>
                <th style={style.th}>접수일</th>
                <th style={{...style.th, color: '#3b82f6'}}>정산완료일</th>
                <th style={style.th}>고객/차량</th>
                <th style={style.th}>정비사</th>
                <th style={{...style.th, textAlign: 'right'}}>부품 매출(공급가)</th>
                <th style={{...style.th, textAlign: 'right'}}>공임 매출(공급가)</th>
                {/* 🚀 마지막 컬럼 헤더도 (공급가)로 교체 */}
                <th style={{...style.th, textAlign: 'right', paddingRight: '30px'}}>총 합계(공급가)</th>
              </tr>
            </thead>
            <tbody>
              {enrichedList.map((r, idx) => {
                // 🚀 마지막 컬럼 데이터도 무조건 순수 공급가인 costExVat를 표출
                const totalCostVal = r.costExVat || Math.round(((Number(r.totalCost) || 0) + (Number(r.discount) || 0)) / 1.1);
                return (
                  <tr key={idx} style={{borderBottom: '1px solid #f1f5f9'}}>
                    <td style={{...style.td, paddingLeft: '20px', color: '#94a3b8', fontWeight: 'bold'}}>{enrichedList.length - idx}</td>
                    <td style={style.td}>
                      <div style={{display: 'flex', gap: '6px', alignItems: 'center'}}>
                        <span style={getStatusBadgeStyle(r.status || '완료')}>{r.status || '완료'}</span>
                        <span style={{padding: '4px 8px', borderRadius: '6px', fontSize: '11px', fontWeight: '800', background: r.repairType==='무상'?'#eff6ff':'#f8fafc', color: r.repairType==='무상'?'#3b82f6':'#64748b', border: '1px solid #e2e8f0'}}>{r.repairType || '유상'}</span>
                      </div>
                    </td>
                    <td style={style.td}>{r.asDate}</td>
                    <td style={{...style.td, color: '#3b82f6', fontWeight: 'bold'}}>{r.settleDate || '-'}</td>
                    <td style={style.td}>
                      <b>{r.customerName}</b><br/>
                      <span style={{fontSize: '12px', color: '#94a3b8'}}>{r.carNumber} {r.vin ? `| ${r.vin}` : ''}</span>
                    </td>
                    <td style={style.td}>{r.mechanic}</td>
                    <td style={{...style.td, textAlign: 'right', fontWeight: '500', color: '#0ea5e9'}}>₩ {r.partsSales.toLocaleString()}</td>
                    <td style={{...style.td, textAlign: 'right', fontWeight: '500', color: '#8b5cf6'}}>₩ {r.laborSales.toLocaleString()}</td>
                    <td style={{...style.td, textAlign: 'right', paddingRight: '30px', fontWeight: '700'}}>₩ {totalCostVal.toLocaleString()}</td>
                  </tr>
                );
              })}
              {enrichedList.length === 0 && <tr><td colSpan="9" style={{...style.td, textAlign:'center', color:'#94a3b8', padding: '30px'}}>지정된 조건 내 매출 발생 내역이 없습니다.</td></tr>}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};

export default SalesSection;